// extracted by mini-css-extract-plugin
export var clauseRow = "_fr-6";
export var emptyState = "_fr-d";
export var filterContent = "_fr-a";
export var filterGroup = "_fr-1";
export var filterGroupContainer = "_fr-0";
export var nestedGroup = "_fr-2";
export var nestedGroupContent = "_fr-b";
export var nestedGroupDepth1 = "_fr-3";
export var nestedGroupDepth2 = "_fr-4";
export var nestedGroupDepth3 = "_fr-5";
export var nestedGroupEmpty = "_fr-c";
export var operatorAnd = "_fr-8";
export var operatorOr = "_fr-9";
export var operatorToggle = "_fr-7";
export var removeGroupButton = "_fr-e";